import { computed, ref } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import { uniqBy } from 'lodash-es';
import { defineStore } from '/builds/gitlab/gitlab-ee/node_modules/pinia/dist/pinia.mjs?vue3';
import { useCommitModalState } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/commit/store/composables/use_commit_modal_state.js?vue3';

export const useCherryPickCommit = defineStore('cherryPickCommit', () => {
  const modalState = useCommitModalState();
  const projects = ref([]);
  const targetProjectId = ref('');
  const targetProjectName = ref('');

  const sortedProjects = computed(() => uniqBy(projects.value, 'id').sort());

  const setSelectedProject = (id) => {
    let branchesEndpoint = modalState.branchesEndpoint.value;

    if (projects.value?.length) {
      branchesEndpoint = projects.value.find((project) => project.id === id).refsUrl;
    }

    targetProjectId.value = id;
    modalState.branch.value = modalState.defaultBranch.value;
    modalState.setBranchesEndpoint(branchesEndpoint);
    modalState.fetchBranches();
  };

  return {
    ...modalState,
    projects,
    targetProjectId,
    targetProjectName,
    sortedProjects,
    setSelectedProject,
  };
});
